<template>
  <div class="contact">
    <div v-for="item in company" :key="item.id">
      <!-- 三个小盒子父元素 -->
      <div>
        <div>
          <img src="../../assets/image/lianxifangshi.png" alt="" />
          <p>检测预约</p>
          <p>{{item.tel}}</p>
        </div>
        <div>
          <img src="../../assets/image/dizhi.png" alt="" />
          <p>{{item.title}}</p>
          <p>地址:{{item.address}}</p>
        </div>
        <div>
          <img src="../../assets/image/youxiang.png" alt="" />
          <p>招聘邮箱:{{item.recruit_email}}</p>
        </div>
      </div>
      <meMap :latLng="item.location" />
    </div>
  </div>
</template>

<script>
import { mapGetters,mapActions } from "vuex";
export default {
  name: "contactG",
  data() {
    return {
      contact_3: [],
    };
  },
  computed: mapGetters(["system", "company"]),
  created() {
   this.getCommon()
  },
  methods: {
    ...mapActions(['getCommon'])
  },
};
</script>

<style scoped lang='less'>
// 联系我们
.contact {
  > div {
    // 三个小盒子父元素
    > div {
      display: flex;
      justify-content: space-around;
      height: 13vw;
      align-items: center;
      >div{
        text-align: center;
        >img{
          width: 5.104vw;
          height:5.885vw;
        }
        >p{
          color: #666;
          font-size:  0.93vw;
          line-height: 1.5;
        }
      }
    }
    >#map{
      width: 77.7vw;
      height: 37.5vw;
    }
  }
  // > div {
  //   margin: 2.08vw auto;
  //   > #map {
  //     width: 77.7vw;
  //     height: 37.5vw;
  //     margin: 0 auto;
  //     + div {
  //       margin: 2.08vw auto;
  //     }
  //   }
  // }
  // .contact_item {
  //   text-align: center;
  //   line-height: 1.8;
  //   img {
  //     margin-bottom: 1.56vw;
  //   }
  // }
  // > .contact_item {
  //   display: block;
  // }
}
</style>


// WEBPACK FOOTER //
// src/components/go/contactG.vue